import * as React from "react";

import { FullPageErrorModal } from "@v1/components/editor/page/FullPageErrorModal";
import EmptyLayout from "@v1/layouts/EmptyLayout";
import { getProjectName } from "@v2/utils/project-utils";
import { useSearchParams } from "react-router-dom";

const ShopifyInstalledOnDifferentProjectLayout = () => {
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get("projectId");
  const projectName = searchParams.get("projectName");
  const shopifyUrl = searchParams.get("shopifyUrl");

  const displayName = getProjectName({
    name: projectName ?? undefined,
    integrations: {
      shopify: {
        store: shopifyUrl ? { shopifyUrl } : undefined,
      },
    },
  });

  return (
    <EmptyLayout>
      <FullPageErrorModal
        isClosable={false}
        details={{
          header: "Shopify Store Connected to Different Shop",
          subheader: `This Shopify store is already connected to "${displayName}" in your workspace.`,
          message:
            "To connect this store to a different shop, you'll need to disconnect it from the current shop first.",
          callToAction: {
            type: "link",
            name: `View ${displayName}`,
            to: projectId ? `/shops/${projectId}` : "/home",
          },
        }}
      />
    </EmptyLayout>
  );
};

export default ShopifyInstalledOnDifferentProjectLayout;
